export const enClientPortalComparablesCategory = {
    titles: {
        yield_and_multiplier: 'Yields and multipliers',
        rent: 'Rents',
    },
    ratings: {},
    marketAreaValueTooltip: 'Comparison value: {{value}}',
    tabs: {
        market_area_value: 'Price per m²',
        market_value: 'Absolute price',
        yield: 'Yield',
        multiplier: 'Multiplier',
        discount_rate: 'Discount rate',
        monthly_rent: 'Rent per month',
        yearly_rent: 'Rent per year',
    },
    units: {
        market_area_value: '€/m²',
        market_value: '€',
        yield: '%',
        multiplier: '',
        discount_rate: '%',
        monthly_rent: '€/m²/month',
        yearly_rent: '€/m²/year',
    },
    chart: {
        emptyLabel: 'No data',
        generatedValuesTooltip:
            'These values were calculated automatically from a related data series (for example, yield to multiplier or monthly rent to annual rent).',
        sourceDateWarning: 'Source older than 12 months',
        relevantDataPoints_one: '{{count}} relevant data point',
        relevantDataPoints_other: '{{count}} relevant data points',
        totalDataPoints: '{{count}} total',
        unknownDataPointCount: 'Data point count unknown',
        unnamedDataSeries: 'Unnamed data series',
    },
    referencePickerLabel: 'COMPARISON VALUE',
    yieldOptions: {
        grossYield: 'Gross yield',
        grossInitialYield: 'Gross initial yield',
    },
    multiplierOptions: {
        grossYieldMultiplier: 'Gross yield multiplier',
        netYieldMultiplier: 'Net yield multiplier',
    },
    valueLabels: {
        absolute: 'Value',
        average: 'Average',
        minimum: 'Min',
        maximum: 'Max',
        median: 'Median',
        mode: 'Mode',
        uppermostQuartile: 'Upper quartile',
        lowestQuartile: 'Lower quartile',
        veryGoodResidentialValue: 'Very good residential value',
        goodResidentialValue: 'Good residential value',
        mediumResidentialValue: 'Medium residential value',
        badResidentialValue: 'Basic residential value',
        veryGoodUsageValue: 'Very good usage value',
        goodUsageValue: 'Good usage value',
        mediumUsageValue: 'Medium usage value',
        badUsageValue: 'Basic usage value',
    },
    observationTime: {
        date: 'Reference date {{date}}',
        range: 'Period {{range}}',
        unknownRange: 'unknown',
    },
    retrievedOn: 'Retrieved on {{date}}',
    sourceDate: {
        year: 'Source from {{date}}',
        dated: 'Source dated {{date}}',
    },
}
